import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from './LanguageContext';

const API_URL = process.env.REACT_APP_API_URL || '';

function formatNumber(n, lang = 'fr') {
  try {
    return new Intl.NumberFormat(lang).format(Number(n) || 0);
  } catch {
    return String(n);
  }
}

export default function Stats() {
  const { t, lang } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let aborted = false;
    const run = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await fetch(`${API_URL}/api/statistics`, { credentials: 'include' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (!json?.success) throw new Error(json?.error || 'Failed to load');
        if (!aborted) setData(json.data || null);
      } catch (e) {
        if (!aborted) setError(e?.message || String(e));
      } finally {
        if (!aborted) setLoading(false);
      }
    };
    run();
    return () => { aborted = true; };
  }, []);

  const items = useMemo(() => {
    const d = data || {};
    return [
      { value: d.total_analyses, label: t('stats.analyzed') },
      { value: d.total_users, label: t('stats.users') },
      { value: d.total_files, label: t('stats.files') },
      
    ];
  }, [data, t]);

  return (
    <section id="stats" className="stats ">
      {loading && !data && (
        <div className="stat pricing-card" key="loading">
          <h3>…</h3>
          <p>{t('stats.analyzed')}</p>
        </div>
      )}
      {!loading && error && (
        <div className="stat pricing-card" key="error">
          <h3>—</h3>
          <p>{error}</p>
        </div>
      )}
      {!error && items.map((s, i) => (
        <div className="stat pricing-card" key={i}>
          <h3>{s.value != null ? formatNumber(s.value, lang) : '—'}</h3>
          <p>{s.label}</p>
        </div>
      ))}
    </section>
  );
}
